'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoiceCode = undefined;

var _VoiceCode2 = require('./VoiceCode');

var _VoiceCode3 = _interopRequireDefault(_VoiceCode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VoiceCode = _VoiceCode3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/VoiceCode/index.js
// module id = 1789
// module chunks = 0